<template>
  <div>
    <!-- Info Nota para RANFS -->
    <div v-if="ranfs" class="row">
      <div class="col-12">
        <b-form>
          <div class="row">
            <h5 class="mb-3">Informações sobre a Nota Fiscal</h5>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Número da Nota Fiscal" label-for="ran_numero">
                <input class="form-control" v-model="localServico.ran_numero"
                       maxlength="15"
                       :class="{'is-invalid': validation.ranNumero }"
                       id="ran_numero" type="text">
                <div v-if="validation.ranNumero" class="invalid-feedback">
                  Informe o número da Nota
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Emissão da Nota Fiscal" label-for="ran_nota_emissao">
                <input class="form-control" v-model="localServico.ran_nota_emissao"
                       :class="{'is-invalid': validation.ranEmissao }"
                       id="ran_nota_emissao" type="date">
                <div v-if="validation.ranEmissao" class="invalid-feedback">
                  Informe a emissão da Nota
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Chave de Acesso da NFS-e Nacional" label-for="ran_not_nsu">
                <input class="form-control" v-model="localServico.ran_not_nsu"
                       maxlength="60"
                       :class="{'is-invalid': validation.ranNsu }"
                       id="ran_not_nsu" type="text">
                <div v-if="validation.ranNsu" class="invalid-feedback">
                  Informe a chave de acesso da NFS-e Nacional
                </div>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>

    <!-- Competência -->
    <div class="row">
      <div class="col-12">
        <b-form>
          <div class="row">
            <h5 class="mb-3">Mês e ano da prestação do serviço (Fato Gerador do Imposto)</h5>
          </div>
          <div v-show="substituicao && !entidade.par_permite_troca_competencia" class="row">
            <b-alert show variant="warning">
              <i class="mdi mdi-alert-outline mr-2"></i>Não é permitida a troca de competência na substituição
              da nota fiscal.
            </b-alert>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Mês" label-for="mes_competencia">
                <select id="mes_competencia"
                        :disabled="substituicao && !entidade.par_permite_troca_competencia"
                        v-model="localCompetencia.mes"
                        class="custom-select"
                        :class="{'is-invalid': validation.mes }"
                        type="text">
                  <option v-for="m in meses" :key="m.codigo" v-bind:value="m.codigo">{{ m.descricao }}</option>
                </select>
                <div v-if="validation.mes" class="invalid-feedback">
                  Informe o mês
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Ano" label-for="ano_competencia">
                <input class="form-control"
                       :disabled="substituicao && !entidade.par_permite_troca_competencia"
                       @change="$emit('alter-ano')"
                       v-model="localCompetencia.ano"
                       v-mask="'####'"
                       :class="{'is-invalid': validation.ano }"
                       id="ano_competencia" type="text">
                <div v-if="validation.ano" class="invalid-feedback">
                  Informe o ano
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Competência" label-for="competencia">
                <input class="form-control" :value="sepCompetencia" disabled
                       id="competencia" type="text">
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>

    <!-- Serviço -->
    <div class="row">
      <h5 class="mb-3">Informação sobre o serviço</h5>
    </div>

    <!-- CNAE -->
    <div v-if="ranfs" class="row">
      <div class="col-md-12">
        <b-form-group label="Cnae" label-for="cnae_codigo">
          <multiselect id="cnae_codigo" v-model="localCnaeAux"
                       placeholder="Selecione o Cnae" track-by="cnae_codigo"
                       :custom-label="customLabelCnae" :options="listCnae"
                       :close-on-select="true" :option-height="104" :loading="isLoading"
                       :searchable="true" :internal-search="false" :allowEmpty="false"
                       :max-height="600" :show-no-results="false"
                       @search-change="$emit('pesquisar-cnae', $event)"
                       :show-labels="false">
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.cnae_codigo }} - {{ props.option.cnae_nome }}</span>
              </div>
            </template>
            <span slot="noOptions">Digite para pesquisar</span>
          </multiselect>
        </b-form-group>
      </div>
    </div>
    <div v-else class="row">
      <div v-if="listCnae && listCnae.length > 0" class="col-md-12">
        <b-form-group label="Cnae" label-for="cnae_codigo">
          <multiselect id="cnae_codigo" v-model="localCnaeAux"
                       placeholder="Selecione o cnae" track-by="cnae_codigo"
                       :allowEmpty="false" :options="listCnae"
                       :custom-label="customLabelCnae" :max-height="600"
                       :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.cnae_codigo }} - {{ props.option.cnae_nome }}</span>
              </div>
            </template>
          </multiselect>
        </b-form-group>
      </div>
    </div>

    <!-- Atividade -->
    <div v-if="ranfs" class="row">
      <div class="col-md-12">
        <b-form-group label="Atividade desenvolvida" label-for="ser_codigo">
          <multiselect id="ser_codigo" v-model="localServico.ser_codigo"
                       placeholder="Selecione a Atividade" track-by="ser_codigo"
                       :custom-label="customLabelAtividade"
                       :class="{'is-invalid': validation.serCodigo}"
                       :options="listAtividades" :close-on-select="true"
                       :option-height="104" :loading="isLoading" :searchable="true"
                       :internal-search="true" :allowEmpty="false" :max-height="600"
                       :show-no-results="false"
                       @select="$emit('select-atividade', $event)"
                       @search-change="$emit('pesquisar-servicos', $event)"
                       :show-labels="false">
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.ser_codigo }} - {{ props.option.ser_descricao }}</span>
              </div>
            </template>
            <span slot="noOptions">Digite para pesquisar</span>
          </multiselect>
          <h6 v-show="validation.serCodigo" class="invalid-feedback">
            Selecione a atividade desenvolvida</h6>
        </b-form-group>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-12">
        <b-form-group label="Atividade desenvolvida" label-for="ser_codigo">
          <multiselect id="ser_codigo" v-model="localServico.ser_codigo"
                       placeholder="Selecione a atividade"
                       :class="{'is-invalid': validation.serCodigo}"
                       track-by="ser_codigo" :allowEmpty="false"
                       :options="listAtividades"
                       @select="$emit('select-atividade', $event)"
                       :custom-label="customLabelAtividade"
                       :max-height="600" :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">
                  {{ formatarCodigo(props.option.ser_codigo) }} -
                  {{ props.option.ser_descricao }}
                </span>
              </div>
            </template>
            <template slot="noOptions">Empresa não possui atividade cadastrada. Entre em contato com a Prefeitura</template>
          </multiselect>
          <h6 v-show="validation.serCodigo" class="invalid-feedback">
            Selecione a atividade desenvolvida</h6>
        </b-form-group>
      </div>
    </div>

    <!-- NBS -->
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="NBS" label-for="nbs_codigo">
          <multiselect id="nbs_codigo" v-model="localServico.nbs_codigo"
                       placeholder="Selecione o NBS"
                       :class="{'is-invalid': validation.nbsCodigo}"
                       v-bind:disabled="!localServico.ser_codigo.ser_codigo"
                       track-by="nbs_codigo" :allowEmpty="false"
                       :options="listNbs" :custom-label="customLabelNBS"
                       :max-height="600" :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">
                  {{ formatarCodigo(props.option.nbs_codigo) }} - {{ props.option.nbs_nome }}
                </span>
              </div>
            </template>
            <template slot="noOptions">Empresa não possui atividade cadastrada. Entre em contato com a Prefeitura</template>
          </multiselect>
          <h6 v-show="validation.nbsCodigo" class="invalid-feedback">Selecione o NBS</h6>
        </b-form-group>
      </div>
    </div>

    <!-- Operação Tributária -->
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Operação Tributária" label-for="iop_codigo">
          <multiselect id="iop_codigo" v-model="localServico.iop_codigo"
                       placeholder="Selecione a operação"
                       v-bind:disabled="!localServico.ser_codigo.ser_codigo"
                       track-by="iop_codigo" :allowEmpty="false"
                       :options="listOperacao" :custom-label="customLabelOperacao"
                       :max-height="600" :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">
                  {{ formatarCodigo(props.option.iop_codigo) }} - {{ props.option?.iop_nome }}
                </span>
              </div>
            </template>
            <template slot="noOptions">Empresa não possui atividade cadastrada. Entre em contato com a Prefeitura</template>
          </multiselect>
        </b-form-group>
      </div>
    </div>

    <!-- Classificação Tributária -->
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Classificação Tributária" label-for="cst_classtrib">
          <multiselect id="cst_classtrib" v-model="localServico.cst_classtrib"
                       placeholder="Selecione a classificação tributária"
                       v-bind:disabled="!localServico.ser_codigo.ser_codigo"
                       track-by="cst_classtrib" :allowEmpty="false"
                       :options="listClassificacao" :custom-label="customLabelClassificacao"
                       :max-height="600" :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">
                  {{ formatarCodigo(props.option.cst_classtrib) }} - {{ props.option.cst_classtrib_nome }}
                </span>
              </div>
            </template>
            <template slot="noOptions">Empresa não possui atividade cadastrada. Entre em contato com a Prefeitura</template>
          </multiselect>
        </b-form-group>
      </div>
    </div>

    <!-- Obra -->
    <div v-if="isObra">
      <div class="row">
        <div class="col-sm-12">
          <h5 class="mb-3">Informação sobre a Obra</h5>
        </div>
        <div class="col-md-12">
          <b-form-group label="Selecione o tipo de Informação">
            <b-form-radio v-model="localServico.obra.sep_obra_tipo"
                          class="custom-radio custom-control-inline"
                          @change="$emit('reseta-obra')"
                          :class="{'is-invalid': validation.obraTipo}"
                          v-bind:value="1">Código de Obra
            </b-form-radio>
            <b-form-radio v-model="localServico.obra.sep_obra_tipo"
                          class="custom-control-inline"
                          @change="$emit('reseta-obra')"
                          :class="{'is-invalid': validation.obraTipo}"
                          v-bind:value="2">Código do Cadastro Imobiliário Brasileiro (CIB)
            </b-form-radio>
            <b-form-radio v-model="localServico.obra.sep_obra_tipo"
                          class="custom-control-inline"
                          @change="$emit('reseta-obra')"
                          :class="{'is-invalid': validation.obraTipo}"
                          v-bind:value="3">Endereço no Brasil
            </b-form-radio>
            <div v-show="validation.obraTipo" class="invalid-feedback">
              Selecione o tipo de informação a ser complementada
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Inscrição Imobiliária Fiscal" label-for="sep_obra_insc_fiscal">
            <input type="text" v-model="localServico.obra.sep_obra_insc_fiscal" class="form-control"
                   maxlength="30" id="sep_obra_insc_fiscal"/>
          </b-form-group>
        </div>
      </div>

      <div v-if="localServico.obra.sep_obra_tipo === 1" class="row">
        <div class="col-md-4">
          <b-form-group label="Código de Obra" label-for="sep_obra_codigo">
            <input type="text" class="form-control"
                   :class="{'is-invalid': validation.obraCodigo}"
                   v-model="localServico.obra.sep_obra_codigo" maxlength="30" id="sep_obra_codigo"/>
            <div v-show="validation.obraCodigo" class="invalid-feedback">
              Informe o código de obra
            </div>
          </b-form-group>
        </div>
      </div>
      <div v-if="localServico.obra.sep_obra_tipo === 2" class="row">
        <div class="col-md-4">
          <b-form-group label="Código do Cadastro Imobiliário Brasileiro (CIB)" label-for="sep_obra_cib">
            <input type="text" class="form-control" v-mask="'#######-#'"
                   :class="{'is-invalid': validation.obraCib}"
                   v-model="localServico.obra.sep_obra_cib" maxlength="9" id="sep_obra_cib"/>
            <div v-show="validation.obraCib" class="invalid-feedback">
              Informe o código do CIB
            </div>
          </b-form-group>
        </div>
      </div>

      <div v-if="localServico.obra.sep_obra_tipo === 3">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="CEP" label-for="sep_obra_end_cep">
              <input id="sep_obra_end_cep" ref="sep_obra_end_cep"
                     v-model="localServico.obra.sep_obra_end_cep"
                     v-on:focusout="$emit('loc-obra', localServico.obra.sep_obra_end_cep)"
                     autocomplete="no" v-mask="'##.###-###'"
                     type="text" maxlength="20" class="form-control" placeholder=" "
                     :class="{'is-invalid': errorCepObra || validation.obraCep}">
              <div v-show="validation.obraCep" class="invalid-feedback">
                Informe o CEP da obra
              </div>
              <div v-show="errorCepObra" class="invalid-feedback">
                CEP não encontrado
              </div>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Endereço/Quadra" label-for="sep_obra_end_logradouro">
              <input id="sep_obra_end_logradouro" ref="sep_obra_end_logradouro"
                     v-model="localServico.obra.sep_obra_end_logradouro"
                     type="text" maxlength="255" class="form-control" placeholder=" "
                     :class="{'is-invalid': submitted && validation.obraLogradouro}">
                <div v-show="validation.obraLogradouro" class="invalid-feedback">
                  Informe o endereço. Máximo de 255 caracteres
                </div>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Número/Lote" label-for="sep_obra_end_numero">
              <input id="sep_obra_end_numero" ref="sep_obra_end_numero"
                     v-model="localServico.obra.sep_obra_end_numero"
                     type="text" maxlength="60" class="form-control" placeholder=" "
                     :class="{'is-invalid': submitted && validation.obraNumero}">
              <div v-show="validation.obraNumero" class="invalid-feedback">
                Informe o número. Máximo de 60 caracteres
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Bairro" label-for="sep_obra_end_bairro">
              <input id="sep_obra_end_bairro"
                     v-model="localServico.obra.sep_obra_end_bairro"
                     type="text" maxlength="60" class="form-control" placeholder=" "
                     :class="{'is-invalid': submitted && validation.obraBairro}">
              <div v-show="validation.obraBairro" class="invalid-feedback">
                Informe o bairro. Máximo de 60 caracteres
              </div>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group label="Complemento" label-for="sep_obra_end_complemento">
              <input id="sep_obra_end_complemento"
                     v-model="localServico.obra.sep_obra_end_complemento"
                     type="text" maxlength="156" class="form-control" placeholder=" ">
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <!-- Tributação ISS -->
    <div class="row">
      <h5 class="mb-3">Informação sobre tributação do ISS</h5>
    </div>

    <!-- Município Prestação -->
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Município onde o serviço foi prestado" label-for="sep_municipio_prestacao">
          <multiselect
              id="sep_municipio_prestacao"
              v-model="localServico.sep_municipio_prestacao"
              placeholder="Selecione município"
              track-by="mun_codigo"
              :custom-label="labelMunicipio"
              :class="{'is-invalid': !localServico.sep_municipio_prestacao.mun_codigo}"
              :options="municipios"
              :close-on-select="true"
              :option-height="104"
              :loading="isLoading"
              :searchable="true"
              :internal-search="false"
              :allowEmpty="false"
              :max-height="600"
              :show-no-results="false"
              @search-change="pesquisarMunicipio"
              :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.mun_nome }} - {{ props.option.mun_uf }}</span>
              </div>
            </template>
            <span slot="noOptions">Digite para pesquisar</span>
          </multiselect>
          <h6 v-show="!localServico.sep_municipio_prestacao.mun_codigo" class="invalid-feedback">
            Informe o município</h6>
        </b-form-group>
      </div>
    </div>

    <div v-show="!isAvulso" class="row">
      <div class="col-sm-12 col-md-4">
        <b-form-group label="Exigibilidade do ISS" label-for="sep_exigibilidade_iss">
          <select id="sep_exigibilidade_iss" v-bind:disabled="true"
                  v-model="localServico.sep_exigibilidade_iss"
                  class="custom-select" type="text">
            <option value="1">Exigível</option>
            <option value="2">Não incidência</option>
            <option value="3">Isenção</option>
            <option value="5">Imune</option>
          </select>
        </b-form-group>
      </div>

      <div class="col-sm-12 col-md-4">
        <b-form-group label="Tributação do ISS" label-for="sep_tributacao_iss">
          <select id="sep_tributacao_iss"
                  v-bind:disabled="verificaTributacao.disableTributacao"
                  v-model="localServico.sep_tributacao_iss"
                  @change="$emit('select-tributacao', localServico.sep_tributacao_iss)"
                  class="custom-select" type="text">
            <option value="1">No Município</option>
            <option v-if="!verificaTributacao.disableForaMunicipio" value="2">Tributada fora do Município</option>
          </select>
        </b-form-group>
      </div>
    </div>
    <div v-show="!isAvulso" class="row">
      <div class="col-md-12">
        <b-form-group label="Município onde é tributado o ISS" label-for="sep_municipio_incidencia">
          <multiselect
              v-if="localServico.sep_tributacao_iss !== '1'"
              id="sep_municipio_incidencia"
              v-model="localServico.sep_municipio_incidencia"
              placeholder="Selecione município"
              :class="{'is-invalid': !localServico.sep_municipio_incidencia.mun_codigo}"
              track-by="mun_codigo" :custom-label="labelMunicipio"
              :options="municipios" :close-on-select="true" :allowEmpty="false"
              :option-height="104" :loading="isLoading" :searchable="true"
              :internal-search="false" :max-height="600" :show-no-results="false"
              @search-change="pesquisarMunicipio" :show-labels="false">
            <template #option="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.mun_nome }} - {{ props.option.mun_uf }}</span>
              </div>
            </template>
            <span slot="noOptions">Digite para pesquisar</span>
          </multiselect>
          <h4 class="mt-3" v-else>{{ localServico.sep_municipio_incidencia.mun_nome }} -
            {{ localServico.sep_municipio_incidencia.mun_uf }}</h4>
          <h6 v-show="!localServico.sep_municipio_incidencia.mun_codigo" class="invalid-feedback">
            Informe o município</h6>
        </b-form-group>
      </div>
    </div>

    <!-- Descrição -->
    <div class="row">
      <div class="col-md-12">
        <button type="button" id="descricaoFav" title="Histórico de Descrições"
                @click="$emit('open-modal-descricoes')"
                class="btn btn-label btn-sm mr-2 mb-2 btn-outline-primary"><i
            class="bx bx-star label-icon"></i> Descrições Favoritas
        </button>
        <b-form-group label="Descrição dos serviço" label-for="sep_discriminacao">
          <textarea v-model="localServico.sep_discriminacao" class="form-control"
                    :class="{'is-invalid': validation.discriminacao }"
                    :maxlength="2000" rows="15"
                    placeholder="Descrição do serviço máximo de 2000 caracteres"></textarea>
          <div class="text-center">
            <p v-if="localServico.sep_discriminacao" class="badge position-absolute"
               :class="{ 'badge-success': localServico.sep_discriminacao.length !== 2000,
                          'badge-danger': localServico.sep_discriminacao.length === 2000 }">
              {{ localServico.sep_discriminacao.length }} / 2000
            </p>
          </div>
          <h6 v-show="validation.discriminacao" class="invalid-feedback">
            Informe a descrição do serviço realizado</h6>
        </b-form-group>
        <div class="form-group">
          <div class="custom-control custom-checkbox mt-2">
            <input id="check-save-descricao-favorito" v-bind:disabled="httpSendSalvaFavorito"
                   @change="$emit('save-descricao-favorito')" v-model="localDescricaoFavorito"
                   type="checkbox" class="custom-control-input">
            <label for="check-save-descricao-favorito" class="custom-control-label text-dark">
              <span v-show="!dsfCodigo">Adicionar descrição aos favoritos </span>
              <span v-show="dsfCodigo">Remover dos favoritos </span>
              <span v-show="httpSendSalvaFavorito">
                <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {autocompleteMunicipio} from "@/api/geral/autocomplete";

export default {
  name: "TabServicos",
  components: {Multiselect},
  props: {
    servico: {type: Object, required: true},
    competencia: {type: Object, required: true},
    entidade: {type: Object, required: true},
    ranfs: {type: Boolean, default: false},
    substituicao: {type: Boolean, default: false},
    isAvulso: {type: Boolean, default: false},
    isObra: {type: Boolean, default: false},
    cnaeAux: {type: Object, default: null},
    listAtividades: {type: Array, default: () => []},
    listCnae: {type: Array, default: () => []},
    listNbs: {type: Array, default: () => []},
    listOperacao: {type: Array, default: () => []},
    listClassificacao: {type: Array, default: () => []},
    meses: {type: Array, default: () => []},
    verificaTributacao: {type: Object, required: true},
    descricaoFavorito: {type: Boolean, default: false},
    dsfCodigo: {default: null},
    httpSendSalvaFavorito: {type: Boolean, default: false},
    errorCepObra: {type: Boolean, default: false},
    submitted: {type: Boolean, default: false},
    validation: {
      type: Object,
      default: () => ({
        mes: false, ano: false, serCodigo: false, discriminacao: false,
        nbsCodigo: false, ranNumero: false, ranEmissao: false, ranNsu: false,
        obraTipo: false, obraCodigo: false, obraCib: false, obraCep: false,
        obraLogradouro: false, obraNumero: false, obraBairro: false,
      })
    },
  },
  data() {
    return {
      municipios: [],
      isLoading: false,
    };
  },
  computed: {
    localServico() { return this.servico; },
    localCompetencia() { return this.competencia; },
    localCnaeAux: {
      get() { return this.cnaeAux; },
      set(val) { this.$emit('update:cnaeAux', val); },
    },
    localDescricaoFavorito: {
      get() { return this.descricaoFavorito; },
      set(val) { this.$emit('update:descricaoFavorito', val); },
    },
    sepCompetencia() {
      if (this.localCompetencia.mes && this.localCompetencia.ano) {
        return `${this.localCompetencia.mes}/${this.localCompetencia.ano}`;
      }
      return '';
    },
  },
  methods: {
    pesquisarMunicipio(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteMunicipio({query: search}).then(response => {
          if (response.status && response.dados) {
            this.municipios = response.dados;
          }
        }).catch(error => {
          console.error(error);
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    labelMunicipio({mun_nome, mun_uf}) {
      return `${mun_nome} - ${mun_uf}`;
    },
    customLabelCnae({cnae_codigo, cnae_nome}) {
      if (!cnae_codigo) return "Digite o código ou descrição do CNAE para pesquisar";
      return `${cnae_codigo} – ${cnae_nome}`;
    },
    customLabelAtividade({ser_codigo, ser_descricao}) {
      if (!ser_codigo) return "Digite o código ou descrição do Atividade para pesquisar";
      return `${this.formatarCodigo(ser_codigo)} – ${ser_descricao}`;
    },
    customLabelNBS({nbs_codigo, nbs_nome}) {
      return `${this.formatarCodigo(nbs_codigo)} – ${nbs_nome}`;
    },
    customLabelOperacao({iop_codigo, iop_nome}) {
      return `${this.formatarCodigo(iop_codigo)} – ${iop_nome}`;
    },
    customLabelClassificacao({cst_classtrib, cst_classtrib_nome}) {
      return `${this.formatarCodigo(cst_classtrib)} – ${cst_classtrib_nome}`;
    },
    formatarCodigo(codigo) {
      if (!codigo) return '';
      return codigo.toString().replace(/^(\d{2})(\d{2})(\d{2})(\d{3})$/, '$1.$2.$3.$4');
    },
    focusObraCep() { this.$refs.sep_obra_end_cep?.focus(); },
    focusObraLogradouro() { this.$refs.sep_obra_end_logradouro?.focus(); },
    focusObraNumero() { this.$refs.sep_obra_end_numero?.focus(); },
  },
};
</script>
